/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { storyblokEditable } from '@storyblok/react/rsc'
import React from 'react'
import { StoryblokImage } from '@/components/storyblok/components/ui/Image'
import { ImageStoryblok } from '@/lib/storyblok/types/generated-types'

/** A description of the available properties for this component. */
type StoryblokManualImageProps = {
  /** The Storyblok blok that represents this component. */
  blok: ImageStoryblok
}

/**
 * A Storyblok component for displaying an image, specifically within the dashboard view for manuals.
 */
const StoryblokManualImage: React.FC<StoryblokManualImageProps> = ({ blok }) => {
  const caption = blok.src.title ?? blok.src.alt

  return (
    <figure className={'inline-block  rounded-xl overflow-hidden my-2.5 p-2'}>
      <StoryblokImage {...storyblokEditable(blok)} blok={blok} />
      {caption && <figcaption className={'mt-2 italic font-medium text-center text-sm'}>{caption}</figcaption>}
    </figure>
  )
}

export { StoryblokManualImage }
